import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { scrollToTop } from "../../srevices/scrollToTop";
import {
  buttonStyles as buttonStylesDark,
  buttonStylesLight as buttonStylesLight,
} from "./Pagination.styles";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 3,
      }}
    >
      <Typography variant="h6" sx={{ marginBottom: 2 }}>
        Страница {currentPage} из {totalPages}
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          onClick={() => {
            onPageChange(currentPage - 1);
            scrollToTop();
          }}
          disabled={currentPage === 1}
          sx={
            isDarkMode
              ? { ...buttonStylesDark(theme) }
              : { ...buttonStylesLight(theme) }
          
          }
        >
          Предыдущая
        </Button>
        <Button
          onClick={() => {
            onPageChange(currentPage + 1);
            scrollToTop();
          }}
          disabled={currentPage === totalPages}
          sx={
            isDarkMode
              ? { ...buttonStylesDark(theme) }
              : { ...buttonStylesLight(theme) }
          }
        >
          Следующая
        </Button>
      </Box>
    </Box>
  );
};

export default Pagination;
